import { apiGateway } from '../api';

async function getContatosPorContrato(numeroContrato, email) {
    if (!numeroContrato) return [];

    try {
        const response = await apiGateway.get(`/contratos/${numeroContrato}/contatos${email ? `?email=${email}` : ''}`);
        return response.data;
    } catch (error) {
        return [];
    }
}

async function adicionarContatoEmContrato(numeroContrato, body) {
    if (!numeroContrato) return [];

    try {
        const response = await apiGateway.post(`/contratos/${numeroContrato}/contatos`, body);
        return response;
    } catch (error) {
        return [];
    }
}

async function alterarContatoDoContrato(numeroContrato, numSequencialContato, body) {
    if (!numeroContrato) return [];

    try {
        const response = await apiGateway.put(`/contratos/${numeroContrato}/contatos/${numSequencialContato}`, body);
        return response;
    } catch (error) {
        return [];
    }
}

async function removerContatoDoContrato(numeroContrato, numSequencialContato) {
    if (!numeroContrato) return [];

    try {
        const response = await apiGateway.delete(`/contratos/${numeroContrato}/contatos/${numSequencialContato}`);
        return response;
    } catch (error) {
        return [];
    }
}

async function getTipoAtendimento(numeroContrato, numeroPlano) {
    if (!numeroContrato || !numeroPlano) return [];

    try {
        const response = await apiGateway.get(`/contratos-congeneres/consultar-tipo-atendimento/contrato/${numeroContrato}/plano/${numeroPlano}`);
        return response;
    } catch (error) {
        return [];
    }
}

export { getContatosPorContrato, adicionarContatoEmContrato, alterarContatoDoContrato, removerContatoDoContrato, getTipoAtendimento };
